{
    "type": {
        "percentage": "Percentage",
        "amount": "Amount",
        "basePrice": "Base price"
    },
    "applicableTo": {
        "BUY": "Buy",
        "GIFT": "Gift",
        "RENEW": "Renew"
    }
}
